"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSearchMeta = void 0;
const app_1 = require("@obvio/app");
const react_1 = require("react");
function useSearchMeta() {
    const searchPath = (0, app_1.useContextPath)('ecommerce.search');
    const { asPath, query, pathname } = (0, app_1.useRouter)();
    const [category, setCategory] = (0, react_1.useState)(query.category);
    const [ready, setReady] = (0, react_1.useState)(false);
    const params = Object.entries(query).reduce((acc, [key, value]) => (Object.assign(Object.assign({}, acc), { [key]: (value === null || value === void 0 ? void 0 : value.includes(',')) ? value.split(',') : value })), {});
    (0, react_1.useEffect)(() => {
        setReady(true);
        const [path] = asPath.split('?');
        const parts = path.split('/');
        const { 2: categoryPart } = parts;
        if (categoryPart !== '[category]') {
            setCategory(categoryPart);
        }
    }, [asPath, category, searchPath]);
    return {
        pathname: pathname.startsWith(searchPath) ? pathname : searchPath,
        category,
        params,
        ready,
    };
}
exports.useSearchMeta = useSearchMeta;
